import React from 'react'
import styled from 'styled-components'
import { useWindowSize } from 'usehooks-ts'

export const PlaceLabel = ({
  x,
  y,
  hideLine,
  label,
  offset
}: {
  x: number
  y: number
  hideLine?: boolean
  label?: string
  offset?: string
}) => {
  const { width } = useWindowSize()

  const offsetbase = width < 712 ? 9 : 14
  
  let offs = [0, 0],
    lineoffs = [0, 4],
    anchor = 'center'
  if (offset) {
    if (offset.includes('top')) {
      offs[1] = -offsetbase * 2
      if (offset === 'top') offs[1] = -offsetbase * 3
      anchor = 'middle'
    }
    if (offset.includes('bottom')) {
      offs[1] = offsetbase * 3
      lineoffs[1] = -12
      anchor = 'middle'
    }
    if (offset.includes('left')) {
      offs[0] = -offsetbase
      anchor = 'end'
      if (!offset.includes('bottom') && !offset.includes('top')) {
        offs[0] = -offsetbase * 2
        offs[1] = -4
      }
    }
    if (offset.includes('right')) {
      offs[0] = offsetbase
      anchor = 'start'
      if (!offset.includes('bottom') && !offset.includes('top')) {
        offs[0] = offsetbase * 2
        offs[1] = -4
      }
    }
  }
  return (
    <PlaceLabelGroup transform={`translate(${x},${y})`}>
      {!hideLine && 
      <MarkerLine
      x1={0}
      x2={offs[0] + lineoffs[0]}
      y1={0}
      y2={offs[1] + lineoffs[1]}
      stroke={'#7D7D7D'}
      strokeWidth={1}
      />
    }
      <Label transform={`translate(${offs[0]},${offs[1]})`} isHorizontal={offset?.includes('right') || offset?.includes('left')}>
        <text className='bg' textAnchor={anchor}>
          {label}
        </text>
        <text textAnchor={anchor}>{label}</text>
      </Label>
    </PlaceLabelGroup>
  )
}
const MarkerLine = styled.line`
  stroke: var(--text-color);
`
const Label = styled.g<{isHorizontal?: boolean}>`
  text {
    font-size: 12px;
    ${({ isHorizontal })=> isHorizontal ? "transform: translateY(0.5em); padding-left: 10px;": ""}
  }
`
const PlaceLabelGroup = styled.g`
    animation: fade-in 0.5s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
    @keyframes fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  font-size: 15px;
  font-weight: 400;
  font-family: var(--font-plex);
  fill: var(--text-color);
  circle {
    fill: #000;
    opacity: 0.6;
  }
  text.bg {
    stroke: var(--site-background);
    stroke-width: 3;
  }
`
